<div class="TextCenter">
	<h4>School Containers</h4>
</div>

<div class="ua-Table">
	<p-table
		#mydt
		[value]="lstContainers"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedContainer"
		dataKey="SchoolGroupID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--SchoolGroupCD-->
				<th>
					<p-columnFilter type="text" field="SchoolGroupCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolGroupDesc-->
				<th>
					<p-columnFilter type="text" field="SchoolGroupDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--School Count-->
				<th></th>

				<!--Active-->
				<th>
					<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="SchoolGroupCD">Code<p-sortIcon field="SchoolGroupCD"></p-sortIcon></th>
				<th pSortableColumn="SchoolGroupDesc">Name<p-sortIcon field="SchoolGroupDesc"></p-sortIcon></th>
				<th pSortableColumn="SchoolsCount">Schools<p-sortIcon field="SchoolsCount"></p-sortIcon></th>
				<th pSortableColumn="Active">Status<p-sortIcon field="Active"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-container>
			<tr [pSelectableRow]="container" (dblclick)="onRowDblClick(container)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ container[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="TextCenter TopMargin">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onEdit()">Edit</button>
	<button class="btn btn-primary" (click)="onToggle()">
		{{ ToggleText }}
	</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
